import { Children, cloneElement, memo } from "react";

import { usePopover } from "./Popover";

import type { ReactElement } from "react";

export interface PopoverTriggerProps {
  children: ReactElement;
}

export const PopoverTrigger = memo(function PopoverTrigger({
  children,
}: PopoverTriggerProps) {
  const { getTriggerProps } = usePopover();

  // Enforce a single child
  const child = Children.only(children);

  return cloneElement(child, getTriggerProps(child.props));
});
